import {
	cookies,
	IHttpService,
	IIntervalService,
	ILocationService,
	IQService,
	IScope,
	ITimeoutService,
	IWindowService
} from "angular";
import { OAuthUser } from "../account/account.model";
import { IRoute, IRouteService } from "../shared/model/route.model";
import { LogBookRootScopeService } from "../shared/model/app.model";
import { User } from "ng/src/app/users/shared/user.model";
import { AppStateService } from "ng/src/app/core/services/app-state.service";
import { AuthClientService } from "ng/src/app/authentication/auth-client.service";

angular.module('logbook')
	.controller('authentication', ['$rootScope', '$scope', '$http', '$location', '$window', '$route', '$q', '$timeout', '$cookies', '$interval', 'appStateService', 'authService',
		function(
			$rootScope: LogBookRootScopeService,
			$scope: IScope,
			$http: IHttpService,
			$location: ILocationService,
			$window: IWindowService,
			$route: IRouteService,
			$q: IQService,
			$timeout: ITimeoutService,
			$cookies: cookies.ICookiesService,
			$interval: IIntervalService,
			appStateService: AppStateService,
			authService: AuthClientService) {
		
			const successUrlCookieId = `login-success-url-${AppStateService.sessionUUID}`;
			const successSearchCookieId = `login-success-search-${AppStateService.sessionUUID}`;

			$rootScope.pathIsEmailValidationOrSignup = (path?: string) => {
				return path && (
					path.indexOf('/validate-email') == 0 ||
					path.indexOf('/signup') == 0
				);
			}

			$rootScope.authenticate = (callback?: () => void) => {
				appStateService.selectedTheme = undefined;

				let deferred = $q.defer(),
					data: User | '' = '';

				$http.get<User | ''>('api/user').then(
					response => {
						if (response.data) {
							
							const redirectCookie = $cookies.get("logbook-auth-redirect");
							if (redirectCookie) {
								$cookies.remove("logbook-auth-redirect");
								$window.location.href = redirectCookie;
							}
							
							data = response.data;

							appStateService.selectedTheme = data.config.theme as 'Light' | 'Dark' | 'Default' | undefined;

							console.log(data);
							console.log(`validated session for ${data.user.firstName} ${data.user.lastName}`);

							let origValidationRequired = $rootScope.user?.validationRequired,
								successUrl = $cookies.get(successUrlCookieId),
								successSearch = $cookies.get(successSearchCookieId);

							console.log('removing success info');
							$cookies.remove(successUrlCookieId);
							$cookies.remove(successSearchCookieId);
							successSearch = successSearch && JSON.parse(successSearch);

							console.log('successUrl=' + successUrl);

							if( !$rootScope.sentLoginRedirect )
							{
								$rootScope.sentLoginRedirect = true;
								$location.path(successUrl || '/');
							}

							if (successSearch)
								$location.search(successSearch);

							$rootScope.authenticated = true;
							appStateService.currentUser = $rootScope.user = data;
							$rootScope.roles = [];

							let isValidated = false;

							data.roles.forEach(role => {
								$rootScope.roles.push(role.authority);

								if (role.authority == 'ROLE_USER')
									isValidated = true;
							})

							if (!isValidated || origValidationRequired) {
								console.log('must validate');

								if (!$rootScope.pathIsEmailValidationOrSignup(successUrl)) {
									$location.url('/validation-required');
									console.log('redirecting to validation-required');
								}

								$rootScope.user.validationRequired = true;
							}
						}
						else {
							$rootScope.authenticated = false;
							appStateService.currentUser = $rootScope.user = undefined;
							$rootScope.roles = [];
							$rootScope.lastAuthenticatedRequest = null;

							deferred.reject();

							$http.get<OAuthUser | ''>('api/oauth2User').then(result => {
								if (result.data)
									$location.url('/oauth-signup');
							})
						}

						callback && callback();

						deferred.resolve(data);
					},
					data => {
						console.log(data);

						callback && callback();
						deferred.reject();
					}
				);

				return deferred.promise;
			};

			$rootScope.sendLoginRedirect = () => {
				
				let url = $cookies.get('logbook-login-page') || '/login';

				$location.url(url);
			};

			$rootScope.verifyAuthentication = () => {
				let successUrl = $cookies.get(successUrlCookieId);
				let callback = () => {
					if (!$rootScope.user && (successUrl || $location.path() === '/') )
						$rootScope.sendLoginRedirect();
				};

				return $rootScope.authenticate(callback, successUrl);
			};

			$rootScope.$on('$routeChangeStart', (event, next?: IRoute) => {
				let preventChange = !$rootScope.authenticated && next?.$$route?.originalPath && !next?.$$route?.public;

				if (preventChange) {
					console.log(`preventing route change to ${next?.$$route?.originalPath}`);
					let successUrl = $location.path();
					let successSearch = JSON.stringify($location.search());
					$location.url('/');
					event.preventDefault();
					$rootScope.$emit('$routeChangeError');

					if (!$rootScope.authVerificationPending) {
						$rootScope.authVerificationPending = true;
						
						if( successUrl && successUrl !== '/login' && successUrl !== '/' && successUrl !== '/logs')
						{
							console.log('setting success-url ' + successUrl);
							$cookies.put(successUrlCookieId, successUrl);
							$cookies.put(successSearchCookieId, successSearch);
						}

						$rootScope.verifyAuthentication().then(
							() => {
								if ($rootScope.user?.validationRequired && !$rootScope.pathIsEmailValidationOrSignup(next?.$$route?.originalPath))
									$location.url('/validation-required');
								
								$rootScope.authVerificationPending = false;
								$route.reload();
							},
							() => $rootScope.authVerificationPending = false
						);
					};
				}
				else if (!$rootScope.authenticated)
					$rootScope.verifyAuthentication();
			});

			$rootScope.logout = () => {
				authService.logout($cookies.get('logbook-login-page'));
			};

			$scope.isCssLoaded = () => {
				if ($rootScope.cssLoaded)
					return true;
				
				let currentTime = new Date().getTime();

				if (!$scope.beganCssLoadCheck) {
					$scope.beganCssLoadCheck = currentTime;
					$scope.cssCheck = $interval(() => $scope.isCssLoaded(), 100);
				}

				let app = $scope.testCss('#app-css-loaded-indicator', 'height', '1px'),
					theme = $scope.testCss('#theme-css-loaded-indicator', 'font-family', 'Glyphicons'),
					dep = $scope.testCss('#dep-css-loaded-indicator', 'font-family', 'FontAwesome');

				$rootScope.cssLoaded = (app && theme && dep) || currentTime - $scope.beganCssLoadCheck > 15000;

				if ($rootScope.cssLoaded) {
					$('#logbook-loading-indicator').css('display', 'none');
					delete $scope.beganCssLoadCheck;
					$scope.cssCheck && $interval.cancel($scope.cssCheck);

					$timeout(() => { }); // ensures that digest cycle is triggered
				}

				return $rootScope.cssLoaded;
			};

			$scope.testCss = (elemId: string, property: string, value: string) => {
				return $(elemId).css(property).indexOf(value) >= 0;
			};
		}
	]);
